const hr = {
  aiNotice: {
    banner: "✨ Engleska i kineska verzija stranice prevedene su uz pomoć napredne umjetne inteligencije (AI).",
    badge: "🤖 AI Prevedeno",
    dropdownNotice: "Engleski i kineski prijevodi generirani su uz pomoć AI modela.",
    modalTitle: "AI Prijevod",
    modalText: "Kako bismo posjetiteljima iz cijelog svijeta približili naše programe, sadržaj na engleskom i kineskom jeziku automatski je preveden uz pomoć najsuvremenijih modela umjetne inteligencije."
  },
  nav: {
    home: "Početna",
    educations: "Edukacije",
    programmerOnline: "Programer/ka umjetne inteligencije - ONLINE",
    programmerLive: "Programer/ka umjetne inteligencije - UŽIVO",
    expertOnline: "Stručnjak/inja za umjetnu inteligenciju - ONLINE",
    aboutUs: "O nama",
    edih: "EDIH",
    blog: "Blog",
    inMedia: "U medijima",
    contact: "Kontakt",
    applyNow: "Prijavi se odmah",
    applyProgrammerOnline: "Programer ONLINE",
    applyProgrammerLive: "Programer UŽIVO",
    applyExpertOnline: "Stručnjak ONLINE",
    languageSelect: "Jezik"
  },
  hero: {
    badge: "Upisi u tijeku",
    title: "Programer/ka umjetne inteligencije - ONLINE",
    learnMoreBtn: "Saznaj više i prijavi se",
    feature1: "Online predavanja i vježbe",
    feature2: "Besplatno osposobljavanje uz HZZ vaučer",
    feature3: "Početak: Studeni 2026."
  },
  home: {
    programHeader: "ONLINE PROGRAM - Studeni 2026.",
    programTitle: "Programer/ka umjetne inteligencije - ONLINE",
    programDesc: "Ovaj program osmišljen je kako bi polaznike kroz intenzivno učenje osposobio za razumijevanje i primjenu ključnih koncepata programiranja, podatkovne znanosti, strojnog i dubokog učenja. Polaznici će naučiti programirati u Pythonu, pripremati i analizirati podatke, primjenjivati modele strojnog učenja, trenirati i evaluirati modele te razvijati praktična rješenja u području analize podataka i umjetne inteligencije.",
    eligibility: "Prihvatljivi polaznici:",
    eligibilityText: "Zaposleni i nezaposleni sa završenom najmanje srednjoškolskom kvalifikacijom na razini 4.2 HKO-a ili višoj.",
    funding: "Način financiranja:",
    fundingText: "HZZ vaučeri, plaćanje putem tvrtke/poslodavca ili samostalno plaćanje polaznika.",
    duration: "Trajanje programa:",
    durationText: "6-9 mjeseci, ovisno o dinamici izvođenja",
    start: "Početak predavanja:",
    startText: "11. mjesec (studeni) 2026.",
    schedule: "Raspored predavanja:",
    scheduleText: "3 puta tjedno, online, s početkom u 17:30 h – prilagođeno zaposlenima",
    visits: "Dolasci u Lipik:",
    visitsText: "Ukupno 5 dolazaka u Lipik (fizički dolazak – petak popodne / subota)",
    ects: "Završetkom ovog programa stječete 21 CSVET/ECTS bod.",
    readMoreBtn: "Pročitajte više i prijavite se",
    blogSectionTitle: "Novosti s našeg bloga",
    blogSectionSubtitle: "Pratite najnovije trendove i savjete iz svijeta umjetne inteligencije",
    readMoreLink: "Pročitaj više →",
    viewAllBlogsBtn: "Vidi sve objave"
  },
  about: {
    header: "O CENTRU UMJETNE INTELIGENCIJE LIPIK",
    title: "Spoj tradicije, vizije i tehnologija budućnosti",
    subtitle: "Kako je slavonski grad s bogatom poviješću postao jedno od najprepoznatljivijih središta za razvoj, učenje i primjenu umjetne inteligencije u Hrvatskoj.",
    historyContext: "POVIJESNI KONTEKST",
    historyTitle: "Od carskog lječilišta do modernog tehnološkog doma",
    historyP1: "Lipik je gradić s iznimno bogatom poviješću – nadaleko poznat po stoljetnoj tradiciji lječilišnog turizma, ljekovitim geotermalnim vrelima, perivoju pod zaštitom države, Kursalonu te svjetski glasovitoj Državnoj ergeli lipicanaca.",
    historyP2: "Nakon teških razaranja u Domovinskom ratu, grad je ustrajnim radom obnovljen. Uz očuvanje kulturne baštine i prirodnih bogatstava, rodila se hrabra ideja: ponuditi mladim ljudima i novim generacijama razlog za dolazak i ostanak u Slavoniji kroz najnaprednije digitalne tehnologije.",
    captionKursalon: "Stoljetni perivoj i Kursalon",
    captionLipizzaner: "Tradicija lipicanaca i perivoja",
    foundingContext: "OSNUTAK I VIZIJA (2021.)",
    foundingTitle: "Centar umjetne inteligencije Lipik",
    foundingP1: "Centar umjetne inteligencije Lipik (AI Center Lipik) službeno je otvoren 30. ožujka 2021. godine u sklopu Lipičke razvojne i turističke agencije LIRA d.o.o.",
    foundingP2: "Cilj projekta bio je jasan: stvoriti ekosustav koji povezuje vrhunsko obrazovanje, mentorsku podršku, moderno opremljene prostore i poticaje za život i rad, stvarajući od Lipika prepoznatljivo regionalno središte za umjetnu inteligenciju.",
    foundingQuote: "„Vizija centra je jednostavna: omogućiti polaznicima stjecanje vještina 21. stoljeća, a poduzetnicima i startupima pružiti dom u kojem mogu rasti.“",
    captionBuilding: "Zgrada AI Centra u Lipiku",
    captionJetracer: "Praktičan rad s AI modelima",
    eduContext: "OBRAZOVANJE I ZNANJE",
    eduTitle: "Edukacijski centar umjetne inteligencije",
    eduSubtitle: "Programi osposobljavanja provode se u suradnji s Fakultetom turizma i ruralnog razvoja u Požegi te uz podršku HZZ vaučera, donoseći polaznicima službene ECTS bodove i mikrokvalifikacije.",
    card1Title: "Stručni nastavni programi",
    card1Desc: "Programi obuhvaćaju Python, analizu podataka, strojno učenje, duboko učenje, računalni vid i obradu prirodnog jezika kroz 600 do 900 sati intenzivne teorije i prakse.",
    card2Title: "Praksa i autonomna vozila",
    card2Desc: "Polaznici primjenjuju teoriju na pravim projektima, uključujući treniranje neuronskih mreža na autonomnim vozilima (JetRacer platforme) i stvarnim skupovima podataka.",
    card3Title: "Iznimna zapošljivost",
    card3Desc: "Kroz centar je prošlo više stotina polaznika iz cijele Hrvatske – od Dubrovnika do Osijeka – uz vrlo visoku stopu zaposlenja u IT industriji odmah nakon završetka.",
    captionClassroom: "Rad u učionici i timsko rješavanje zadataka",
    captionGraduates: "Uspješno promovirani polaznici programa",
    startupContext: "PODRŠKA PODUZETNIŠTVU (2022.)",
    startupTitle: "Startup inkubator i akcelerator",
    startupP1: "Krajem 2022. godine u Lipiku je otvoren Startup inkubator umjetne inteligencije na više od 400 m² suvremenog prostora, s uredima, coworking zonama, sobom za opuštanje, laboratorijem i serverskom infrastrukturom.",
    startupP2: "Inkubator mladim tvrtkama i obrtima nudi:",
    startupLi1: "Kompletno opremljene urede i brzi optički internet",
    startupLi2: "Mentorsku podršku vrhunskih stručnjaka iz industrije",
    startupLi3: "Poticaje za otvaranje poslovanja od strane Grada Lipika, Županije i HZZ-a",
    startupLi4: "Mjere podrške pri rješavanju stambenog pitanja za mlade obitelji",
    startupP3: "Do danas je kroz proces inkubacije prošlo preko 15 malih tvrtki i obrta koji iz Lipika razvijaju softverska rješenja za klijente u Hrvatskoj i inozemstvu.",
    captionIncubatorBuilding: "Zgrada Startup inkubatora",
    captionIncubatorOffice: "Moderni radni prostori za timove",
    partnerContext: "STRATEŠKA PARTNERSTVA",
    partnerTitle: "Partnerstva s gospodarstvom i javnim sektorom",
    finaTitle: "Razvojni centar FINA",
    finaDesc: "U sklopu centra djeluje Razvojni centar za umjetnu inteligenciju koji je osnovala Financijska agencija (FINA). U njemu su zaposleni programeri koji rade na naprednim sustavima analize podataka i razvoju novih AI funkcionalnosti za financijski sektor.",
    edihTitle: "AI & Gaming EDIH",
    edihDesc: "Lipik je jedan od ključnih partnera u AI & Gaming EDIH-u – europskom digitalnom inovacijskom središtu (jednom od samo 4 u Hrvatskoj), kroz koji besplatno pomažemo digitalnu transformaciju malih i srednjih poduzeća te javnih institucija.",
    ctaTitle: "Zainteresirani ste za naše programe ili suradnju?",
    ctaDesc: "Bilo da želite usvojiti vještine programiranja umjetne inteligencije ili razviti svoj startup u našem inkubatoru, naša vrata su vam otvorena.",
    ctaBtnEdu: "Pogledajte edukacije",
    ctaBtnContact: "Kontaktirajte nas"
  },
  programmerOnline: {
    header: "ONLINE PROGRAM - Studeni 2026.",
    title: "Programer/ka umjetne inteligencije - ONLINE",
    desc: "Ovaj program osmišljen je kako bi polaznike kroz intenzivno učenje osposobio za razumijevanje i primjenu ključnih koncepata programiranja, podatkovne znanosti, strojnog i dubokog učenja. Polaznici će naučiti programirati u Pythonu, pripremati i analizirati podatke, primjenjivati modele strojnog učenja, trenirati i evaluirati modele te razvijati praktična rješenja u području analize podataka i umjetne inteligencije. Program obuhvaća i primjenu dubokog učenja u području računalnog vida.",
    collab: "Program se provodi u suradnji s Fakultetom turizma i ruralnog razvoja u Požegi.",
    start: "Početak predavanja: 11. mjesec (studeni) 2026.",
    schedule: "Raspored predavanja: 3 puta tjedno, online, s početkom u 17:30 h – prilagođeno zaposlenima",
    visits: "Dolasci u Lipik: Ukupno 5 dolazaka u Lipik (fizički dolazak – petak popodne / subota)",
    ects: "Završetkom ovog programa stječete 21 CSVET/ECTS bod.",
    applyBtn: "Prijavite se odmah",
    curriculumTitle: "Program i terminski plan osposobljavanja",
    eligible: "Prihvatljivi polaznici:",
    eligibleText: "Zaposleni i nezaposleni sa završenom najmanje srednjoškolskom kvalifikacijom na razini 4.2 HKO-a ili višoj. Poželjno je da polaznici imaju osnovna znanja iz matematike, logičkog razmišljanja i rada na računalu, a prednost je prethodno iskustvo u programiranju i/ili radu s podacima. Program je namijenjen osobama koje se žele dodatno usavršavati u području umjetne inteligencije te osobama koje se žele dokvalificirati ili prekvalificirati radi veće konkurentnosti na tržištu rada.",
    funding: "Način financiranja:",
    fundingText: "HZZ vaučeri, plaćanje putem tvrtke/poslodavca ili samostalno plaćanje polaznika.",
    cert: "Naziv potvrde po završetku:",
    certText: "Potvrda o usavršavanju za stjecanje mikrokvalifikacije \"Analitičar/ka za strojno i duboko učenje\". Završetkom programa stječe se 21 ECTS bod.",
    skills: "Znanja, vještine i sposobnosti koje se stječu programom:",
    skillsText: "Polaznici usvajaju temeljne koncepte programiranja, algoritama i struktura podataka, metode pripreme i obrade podataka za analizu, principe rada algoritama strojnog i dubokog učenja, pristupe evaluaciji modela i osnovne arhitekture neuronskih mreža. Osposobljavaju se za formuliranje analitičkog problema i njegovo prevođenje u programski zadatak, implementaciju algoritama za obradu podataka i modela strojnog učenja u Pythonu, pripremu i transformaciju skupova podataka, treniranje, testiranje i evaluaciju modela te korištenje programskih biblioteka i alata za analizu podataka i razvoj modela. Po završetku programa moći će samostalno rješavati analitičke probleme koristeći metode podatkovne znanosti, odabrati odgovarajući pristup modeliranju, interpretirati rezultate modela, komunicirati rezultate tehničkoj i netehničkoj publici te prilagoditi rješenja stvarnim zahtjevima i ograničenjima.",
    curriculumHeader: "Nastavni program:",
    m1: "Programiranje u programskom jeziku Python – 180 sati (50 predavanja, 70 vježbi, 60 samostalnih aktivnosti)",
    m2: "Uvod u podatkovnu znanost – 210 sati (50 predavanja, 90 vježbi, 70 samostalnih aktivnosti)",
    m3: "Strojno učenje – 90 sati (20 predavanja, 40 vježbi, 30 samostalnih aktivnosti)",
    m4: "Duboko učenje i računalni vid – 150 sati (40 predavanja, 60 vježbi, 50 samostalnih aktivnosti)",
    totalHours: "Ukupno: 630 sati (160 sati predavanja, 260 sati vježbi, 210 sati samostalnih aktivnosti) – 21 ECTS bod",
    duration: "Trajanje programa:",
    durationText: "6-9 mjeseci, ovisno o dinamici izvođenja i rasporedu nastave.",
    startDetail: "Početak predavanja: 11. mjesec (studeni) 2026.",
    scheduleDetail: "Raspored predavanja: 3 puta tjedno, online, s početkom u 17:30 h – prilagođeno zaposlenima.",
    visitsDetail: "Dolasci u Lipik: Ukupno 5 dolazaka u Lipik (fizički dolazak – petak popodne / subota).",
    location: "Mjesto održavanja:",
    locationText: "Predavanja i vježbe održavaju se online, uz ukupno 5 dolazaka u prostorije Centra umjetne inteligencije Lipik (petak popodne / subota).",
    otherWaysTitle: "Ostali načini prijave",
    otherWaysSubtitle: "Prijaviti se možete i na jedan od sljedećih načina:",
    byEmail: "E-mailom:",
    byEmailText: "Pošaljite e-mail na adresu gabrijela.mijatovic@lipik.ai sa sljedećim podacima: Ime i Prezime, e-mail, broj telefona. Nakon prijave, naši djelatnici kontaktirat će vas u vezi daljnjeg postupka prijave.",
    byPhone: "Telefonski:",
    byPhoneText: "Nazovite na broj +385 (0)99 3808 436 (Gabrijela).",
    inPerson: "Osobnim dolaskom:",
    inPersonText: "Dođite u prostorije Centra umjetne inteligencije Lipik, na adresi Hrvatske mladeži 32, 34551 Lipik. Radno vrijeme: ponedjeljak - petak, od 7 do 15 sati."
  },
  programmerLive: {
    header: "OSPOSOBLJAVANJE UŽIVO U LIPIKU - Proljeće 2027.",
    title: "Programer/ka umjetne inteligencije - UŽIVO",
    desc: "Ovaj program osmišljen je kako bi polaznike kroz intenzivno učenje osposobio za razumijevanje i primjenu ključnih koncepata programiranja, podatkovne znanosti, strojnog i dubokog učenja. Polaznici će naučiti programirati u Pythonu, pripremati i analizirati podatke, primjenjivati modele strojnog učenja, trenirati i evaluirati modele te razvijati praktična rješenja u području analize podataka i umjetne inteligencije. Program obuhvaća i primjenu dubokog učenja u području računalnog vida.",
    collab: "Program se provodi u suradnji s Fakultetom turizma i ruralnog razvoja u Požegi.",
    start: "Početak predavanja: Proljeće 2027.",
    lectures: "Predavanja: Petkom popodne i subotom u Lipiku",
    exercises: "Vježbe: Online u jednom tjednom terminu",
    ects: "Završetkom ovog programa stječete 21 CSVET/ECTS bod.",
    durationText: "6 mjeseci.",
    locationText: "Predavanja se održavaju uživo u prostorijama Centra umjetne inteligencije Lipik (petkom popodne i subotom), dok se vježbe održavaju online."
  },
  expertOnline: {
    header: "ONLINE PROGRAM - Proljeće 2027.",
    title: "Stručnjak/inja za umjetnu inteligenciju - ONLINE",
    desc: "Ovaj program je osmišljen kako bi polaznike osposobio za samostalnu izradu vlastitih programskih rješenja koristeći programski jezik Python, prikupljanje i obradu podataka, implementiranje algoritama strojnog učenja, dizajniranje vlastite neuronske mreže, razvijanje rješenja baziranih na različitim arhitekturama dubinskog učenja u područjima računalnog vida i obrade prirodnog jezika.",
    collab: "Program se provodi u suradnji s Fakultetom turizma i ruralnog razvoja u Požegi",
    start: "Početak predavanja za novu grupu: Proljeće 2027.",
    ects: "Završetkom ovog programa stječete 30 CSVET/ECTS bodova.",
    eligibleText: "Zaposleni, nezaposleni s minimalno završenim stručnim ili sveučilišnim preddiplomskim studijem",
    certText: "Potvrda o usavršavanju za stjecanje mikrokvalifikacije Stručnjak/inja za umjetnu inteligenciju. Završetkom ovog programa stječete 30 CSVET/ECTS bodova.",
    fundingText: "HZZ Vaučeri (besplatno za polaznike), plaćanje putem tvrtke/poslodavca uz HZZ sufinanciranje ili samostalno plaćanje od strane polaznika.",
    skillsText: "Savladati sve bitne koncepte programskog jezika Python, razumjeti pojmove i koncepte strojnog učenja, definirati i opisati temeljne koncepte neuronskih mreža, definirati način funkcioniranja algoritama dubinskog učenja, primijeniti odabranu arhitekturu dubinskog učenja za pojedini problem, analizirati programska rješenja zasnovana na algoritmima obrade slike i računalnog vida, savladati postupke pripreme podataka, razumjeti pojmove i primijeniti koncepte obrade prirodnog jezika.",
    m1: "Programiranje u programskom jeziku Python – 150 sati (40 predavanja, 60 vježbi, 50 samostalne aktivnosti)",
    m2: "Strojno učenje – 150 sati (40 predavanja, 60 vježbi, 50 samostalne aktivnosti)",
    m3: "Duboko učenje – 240 sati (70 predavanja, 90 vježbi, 80 samostalne aktivnosti)",
    m4: "Računalni vid – 120 sati (30 predavanja, 50 vježbi, 40 samostalne aktivnosti)",
    m5: "Uvod u podatkovnu znanost – 150 sati (40 predavanja, 60 vježbi, 50 samostalne aktivnosti)",
    m6: "Obrada prirodnog jezika – 90 sati (20 predavanja, 40 vježbi, 30 samostalne aktivnosti)",
    totalHours: "Ukupno: 900 sati (240 predavanja, 360 vježbi, 300 samostalnih aktivnosti) – 30 ECTS bodova",
    scheduleTerms: "Termini predavanja i vježbi:",
    term1: "Dva do tri puta tjedno ONLINE po 4 školska sata u popodnevnim satima (detaljan raspored ćete dobiti za svaki mjesec ovisno o profesoru koji drži predavanja i vježbe),",
    term2: "Ukupno 6 dolazaka u Lipik u godinu dana (nakon svakog poglavlja nastavnog programa) na bonus predavanja (petak popodne) i provjere znanja (subota ujutro)",
    durationText: "12 mjeseci (600 školskih sati predavanja i vježbi, 300 školskih sati samostalnog učenja uz izradu vlastitog projekta)"
  },
  edih: {
    header: "EUROPSKI DIGITALNI INOVACIJSKI HUB",
    title: "AI & GAMING (JURK) EDIH",
    desc: "AI & GAMING (JURK) EDIH djeluje kao one-stop shop i predstavlja središte digitalizacije i digitalne transformacije za male i srednje poduzetnike te za javni sektor na području središnje Hrvatske i na sjevernom Jadranu. EDIH nudi mogućnost uvođenja svih digitalnih tehnologija u poslovanje poslovnog subjekta ili institucije iz javnog sektora, a s posebnom stručnošću iz područja umjetne inteligencije, gamifikacije i Blockchaina.",
    subDesc: "Digitalna transformacija malog i srednjeg poduzetništva te javnog sektora",
    contactBtn: "Kontaktirajte nas",
    servicesTitle: "Usluge",
    servicesIntro: "Sve usluge EDIH-a usmjerene su na provedbu digitalne transformacije poduzetništva i javnog sektora i za krajnje korisnike su potpuno besplatne! Projektom su obuhvaćene sljedeće usluge:",
    s1: "Test digitalne spremnosti",
    s2: "Podrška u komercijalizaciji inovativnih projekata i ideja",
    s3: "Test before invest (Testiranje prije ulaganja)",
    s4: "Izrada digitalnih blizanaca (digital twin)",
    s5: "Edukacije i treninzi (Digitalne poslovne vještine, gamifikacija, Blockchain, IoT, Boot kampovi)",
    s6: "24/7 online Microsoft trening i skiling platforma",
    s7: "Usluge digitalizacije za medicinsku rehabilitaciju",
    s8: "Poslovne i tehnološke konzultacije",
    s9: "Pitch treninzi i pripreme za crowdfunding kampanje",
    s10: "Povezivanje s investitorima i olakšavanje pristupa financiranju",
    s11: "Umrežavanje s drugim EDIH-ovima u EU",
    consortiumTitle: "Konzorcij",
    consortiumIntro: "Aktivnosti digitalizacije i digitalne transformacije provode se u konzorciju koji je sastavljen od 8 partnera:",
    c1: "Javna ustanova regionalni koordinator Sisačko-moslavačke županije",
    c2: "Razvojna agencija SIMORA – Poduzetnički inkubator PISMO",
    c3: "Institut za fiziku Sveučilišta u Zagrebu",
    c4: "Fakultet za organizaciju i informatiku Sveučilišta u Zagrebu (FOI)",
    c5: "Veleučilište PAR Rijeka",
    c6: "Centar za umjetnu inteligenciju Lipik - Razvojna agencija LIRA",
    c7: "HashNET d.o.o.",
    c8: "FAST LANE d.o.o.",
    focusTitle: "Fokus područja djelovanja",
    focusIntro: "Projekti digitalizacije i digitalne transformacije provode se za klijente iz svih djelatnosti, a poseban fokus je na sljedećim sektorima:",
    f1: "Razvoj video igara",
    f2: "Poljoprivreda (autonomna vožnja)",
    f3: "Turizam",
    f4: "Medicinska rehabilitacija",
    f5: "Drvna industrija",
    f6: "Građevina",
    f7: "Farmacija",
    f8: "Obrazovanje",
    aboutProjectTitle: "O projektu",
    aboutP1: "EDIH se u ukupnom iznosu od 2,3 milijuna eura sufinancira sredstvima Europske komisije kroz program DIGITAL EUROPE i sredstvima iz Nacionalnog programa otpornosti i oporavka 2021. – 2026. Projekt je započeo 1. prosinca 2022. godine.",
    aboutP2: "AI & GAMING (JURK) EDIH dio je mreže inicijalnih europskih digitalnih inovacijskih središta koja broji 151 hub, od čega ih je u Hrvatskoj samo 4."
  },
  blog: {
    header: "Blog",
    subtitle: "Pratite najnovije vijesti, savjete i analize iz AI industrije.",
    readMore: "Pročitaj više",
    backToBlog: "← Povratak na blog",
    author: "Autor:",
    date: "Datum:",
    notFound: "Blog post nije pronađen.",
    interestedTitle: "Zanimaju vas naše edukacije?",
    programOnlineBtn: "Programer (Online)",
    programLiveBtn: "Programer (Uživo)",
    expertOnlineBtn: "AI Stručnjak (Online)"
  },
  media: {
    header: "MEDIJSKE OBJAVE I ČLANCI",
    title: "Centar umjetne inteligencije Lipik u medijima",
    subtitle: "Pogledajte što su o našim edukacijama, polaznicima, startup inkubatoru i razvoju umjetne inteligencije pisali vodeći nacionalni i lokalni mediji.",
    all: "Sve objave",
    national: "Nacionalni mediji",
    local: "Lokalni mediji",
    business: "Poslovni mediji",
    video: "TV / Video",
    sortNewest: "Najnovije",
    sortOldest: "Najstarije",
    readFullArticle: "Pročitaj cijeli članak na",
    noArticles: "Nema objava za odabrani filter."
  },
  contact: {
    title: "Kontakt",
    subtitle: "Imate pitanja? Kontaktirajte nas putem e-maila, telefona ili nas posjetite u Lipiku.",
    addressTitle: "ADRESA:",
    address: "Centar umjetne inteligencije Lipik\nHrvatske mladeži 32\n34551 Lipik",
    phoneTitle: "TELEFON:",
    phone: "Mobilni broj: +385 (0)99 3808 436 (Gabrijela)",
    emailTitle: "E-MAIL:",
    email: "gabrijela.mijatovic@lipik.ai",
    hoursTitle: "RADNO VRIJEME:",
    hours: "Ponedjeljak - petak: 7:00 - 15:00",
    mapTitle: "AI Center Lipik Lokacija"
  },
  form: {
    title: "Prijavite se odmah",
    subtitleSingle: "Popunite obrazac u nastavku i osigurajte svoje mjesto na programu.",
    subtitleMulti: "Popunite obrazac u nastavku i osigurajte svoje mjesto na našim programima.",
    successAlert: "Vaša prijava je uspješno poslana! Hvala vam na interesu.",
    errorAlert: "Došlo je do greške pri slanju. Provjerite kontakt podatke.",
    captchaError: "Pogrešan rezultat matematičkog zadatka. Pokušajte ponovno.",
    selectProgramLabel: "Odaberite program",
    selectProgramPlaceholder: "Odaberite program za koji se prijavljujete",
    prog1: "Programer/ka umjetne inteligencije - ONLINE",
    prog2: "Programer/ka umjetne inteligencije - UŽIVO",
    prog3: "Stručnjak/inja za umjetnu inteligenciju - ONLINE",
    nameLabel: "Ime i prezime",
    namePlaceholder: "Unesite vaše ime i prezime",
    emailLabel: "E-mail adresa",
    emailPlaceholder: "vas@email.com",
    phoneLabel: "Broj telefona",
    phonePlaceholder: "+385 9x xxx xxxx",
    educationLabel: "Stupanj obrazovanja",
    educationPlaceholder: "Odaberite stupanj obrazovanja",
    eduSSS: "Srednja stručna sprema (SSS)",
    eduVSS1: "Viša stručna sprema (VŠS)",
    eduVSS2: "Visoka stručna sprema (VSS)",
    messageLabel: "Motivacijska poruka ili pitanje (opcionalno)",
    messagePlaceholder: "Zašto želite upisati ovaj program ili nas nešto želite pitati?",
    captchaLabel: "Potvrda da niste robot:",
    captchaPlaceholder: "Unesite rezultat",
    gdprLabel: "Slažem se da se moji osobni podaci smiju koristiti u svrhu provođenja prijave na program i daljnje komunikacije sukladno GDPR-u.",
    submitBtn: "Pošalji prijavu",
    submittingBtn: "Slanje..."
  },
  privacy: {
    title: "Izjava o zaštiti osobnih podataka",
    subtitle: "Vaša privatnost nam je izuzetno važna.",
    p1: "Centar umjetne inteligencije Lipik prikuplja i obrađuje osobne podatke korisnika putem online prijavnih obrazaca u svrhu prijave na edukacijske programe i komunikacije s prijavljenim osobama.",
    p2: "Prilikom prijave mogu se prikupljati osnovni kontaktni podaci i informacije potrebne za obradu prijave, poput imena i prezimena, e-mail adrese, broja telefona te podataka vezanih uz obrazovanje ili korištenje HZZ vaučera.",
    p3: "Tijekom daljnjeg postupka prijave od kandidata se može zatražiti dostava dodatne dokumentacije potrebne za nastavak prijavnog postupka i upis u program.",
    p4: "Prikupljeni podaci koriste se isključivo za obradu prijave, kontaktiranje prijavljenih osoba i slanje informacija vezanih uz edukacijske programe Centra umjetne inteligencije Lipik.",
    p5: "Slanjem svojih podataka putem prijavnog obrasca korisnik potvrđuje da je upoznat s ovom Izjavom o zaštiti osobnih podataka te daje privolu Centru umjetne inteligencije Lipik za obradu dostavljenih podataka u navedenu svrhu.",
    cookiesTitle: "Kolačići (Cookies)",
    cookiesText: "Ova web stranica koristi kolačiće (cookies) kako bi vam pružila bolje korisničko iskustvo i funkcionalnost. Nastavkom pregleda stranice slažete se s korištenjem kolačića.",
    contactTitle: "Kontakt",
    contactText: "Za sva pitanja vezana uz obradu osobnih podataka možete se obratiti na:",
    email: "E-mail:",
    address: "Adresa: Centar umjetne inteligencije Lipik, Hrvatske mladeži 32, 34551 Lipik"
  },
  footer: {
    companyName: "CENTAR UMJETNE INTELIGENCIJE LIPIK",
    companyAgency: "Lipička razvojna i turistička agencija Lipik d.o.o.",
    companyAddress: "Hrvatske mladeži 32, 34551 Lipik",
    companyOib: "OIB: 54639446953",
    navHeader: "Edukacije i programi",
    progOnline: "Programer/ka umjetne inteligencije - ONLINE",
    progLive: "Programer/ka umjetne inteligencije - UŽIVO",
    progExpert: "Stručnjak/inja za umjetnu inteligenciju - ONLINE",
    inMedia: "Centar u medijima",
    contactHeader: "KONTAKT",
    phone: "mob | +385 (0)99 3808 436 (Gabrijela)",
    email: "e-mail | gabrijela.mijatovic@lipik.ai",
    privacyLink: "Izjava o zaštiti osobnih podataka",
    allRightsReserved: "Sva prava pridržana.",
    backToTop: "Povratak na vrh",
    aiDisclaimer: "Prevođenje na engleski i kineski jezik podržano je tehnologijom umjetne inteligencije."
  },
  cookies: {
    text: "Ova web stranica koristi kolačiće kako bi vam osigurala najbolje iskustvo. Nastavkom surfanja slažete se s korištenjem kolačića. Saznajte više u",
    privacyLink: "Pravilima privatnosti",
    acceptBtn: "Pristajem"
  },
  accessibility: {
    title: "Pristupačnost",
    increaseFont: "A+ Povećaj tekst",
    decreaseFont: "A- Smanji tekst",
    contrast: "Visoki kontrast",
    dyslexic: "Dyslexic Font",
    underline: "Podcrtaj linkove",
    reset: "Resetiraj postavke"
  },
  admin: {
    title: "Administracija",
    subtitle: "Unesite pristupni kod za pregled prijava.",
    codePlaceholder: "Kod",
    submitBtn: "Pristupi podacima",
    wrongCode: "Pogrešan kod!",
    tableTitle: "Popis prijava",
    exportBtn: "Spremi kao Excel (.csv)",
    loading: "Učitavanje podataka...",
    noData: "Trenutno nema zaprimljenih prijava.",
    thDate: "Datum",
    thName: "Ime i prezime",
    thEmail: "E-mail",
    thPhone: "Telefon",
    thProgram: "Program"
  }
};

export default hr;
